import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { uniqueId, includes, isEmpty, forEach } from 'lodash';
import SweetScroll from 'sweet-scroll';

//import { accountRoute } from '../../routes';

// import Splitter from '../account/block/splitter';
// import ContentBlock from '../account/block/content';
// import SubmitBlock from '../account/block/submit';
import Spinner from '../svg/spinner';

import axios from 'axios';
import qs from 'qs';
import baseUrl from '../../utils/baseUrl';
// import connect from '../../utils/connect';
import { dispatchError, dispatchMsg } from '../../actions/errors';

import css from './form.scss';

export function formatErrors(errors) {
	let fieldsWithErrors = [];

	if (typeof errors === 'object' && Object.keys(errors).length) {
		let keys = Object.keys(errors);

		for (var i = 0; i < keys.length; i++) {
			let errorArr = typeof errors[keys[i]] !== 'object' ? [errors[keys[i]]] : errors[keys[i]];
			if (keys[i] && errorArr) {
				fieldsWithErrors.push({
					name: keys[i],
					errors: errorArr,
				});
			}
		}
	}

	return fieldsWithErrors;
}

export default class Form extends Component {
	static propTypes = {
		dispatch: PropTypes.func.isRequired,
		method: PropTypes.string,
		action: PropTypes.string.isRequired,
		getRefs: PropTypes.func.isRequired,
		disableErrors: PropTypes.bool,
		disableAjaxSubmit: PropTypes.bool,
		onSubmit: PropTypes.func,
		head: PropTypes.oneOfType([
			PropTypes.oneOf([false]),
			PropTypes.object,
		]).isRequired,
	};

	static defaultProps = {
		method: 'post',
		action: '',
		head: false,
		disableErrors: false,
		disableAjaxSubmit: false,
		dispatch: () => {},
		getRefs: () => {},
		onSubmit: (promise) => { promise.then(() => {}).catch(() => {}); },
	};

	constructor(props) {
		super();

		this.mounted = true;

		this.state = {
			id: uniqueId('id'),
			waiting: false,
			fieldsWithErrors: [],
		};
	}

	componentWillMount() {}

	componentWillReceiveProps(nextProps) {}

	componentWillUpdate(nextProps, nextState) {}

	componentWillUnmount() {
		this.mounted = false;
	}

	render() {
		if (this.state.waiting) {
			return this.renderWaiting();
		}

		let spanClass = 'push5 span9';

		if (this.props.smallAside) {
			spanClass = 'push3-desktop span9-desktop push0 span100p';
		}

		if (this.props.commentForm) {
			spanClass = 'push0 span100p';
		}


		if (this.props.newsletterForm) {
			spanClass = 'push0 span100p';
		}

		return (
			<form {...this.props} noValidate={true} ref='form' onSubmit={this.submit.bind(this)} id={this.state.id}>
				{this.props.head}

				{(!this.props.disableErrors && !!this.state.fieldsWithErrors.length) && (
					<div className='form-errors' ref='errors'>

						<div className={spanClass}>
							<ol>
								{this.state.fieldsWithErrors.map(this.renderError.bind(this))}
							</ol>
						</div>

					</div>
				)}

				{this.props.children}
			</form>
		);
	}

	renderError(errObj, i) {
		if (!errObj.errors || !errObj.errors.length || typeof errObj.errors.map !== 'function') {
			return false;
		}

		let refs = this.props.getRefs();
		let curRef = refs[errObj.name];
		let label = ''; // errObj.name

		if (curRef && curRef.props) {
			label = curRef.props.label;
		}

		return errObj.errors.map((err, k) => {
			return (
				<li key={k}><strong>{label}</strong> {err}</li>
			);
		});
	}

	submit(e) {
		e && e.preventDefault && e.preventDefault();
		let allowedMethods = ['post', 'get', 'delete', 'put'];
		let method = 'post';

		if (includes(allowedMethods, this.props.method)) {
			method = this.props.method;
		}

		this.props.onSubmit(
			new Promise((resolve, reject) => {
				if (!this.props.disableAjaxSubmit) {
					axios[method](baseUrl + this.props.action, qs.stringify(this.serialize()))
					.then((response) => {
						this.clearErrorState();

						if (response.data && response.data.message) {
							this.props.dispatch(dispatchMsg(response.data));
						}

						resolve(response);
					})
					.catch((response) => {
						this.setErrorState(response.data, response.status);

						if (response.data && response.data.message) {
							this.props.dispatch(dispatchError(response.data));
						}

						reject(response);
					});
				} else {
					resolve(this.serialize());
				}
			})
		);
	}

	clearErrorState() {
		this.mounted && this.setState({
			...this.state,
			fieldsWithErrors: [],
		});
	}

	setErrorState(data, status) {
		let fieldsWithErrors = formatErrors(data.errors);

		if (status === 500) {
			let msgs = [
				'Please try again in a few minutes.',
				//'Developers have been notified.',
				//'What does it all mean? do I even exist?',
				//'A blessing of unicorns has been dispatched to take care of the issue!',
			];

			let msg = this.props.noFun ? '' : msgs[Math.floor(msgs.length * Math.random())];

			fieldsWithErrors.push({
				name: 'Oops!',
				errors: ['A server error occurred. ' + msg],
			});

			if (data.message) {
				fieldsWithErrors.push({
					name: 'Error',
					errors: [data.message],
				});
			}
		}

		if (status === 401) {
			fieldsWithErrors.push({
				name: 'Error',
				errors: 'Please login to continue',
			});

			if (data.message) {
				fieldsWithErrors.push({
					name: 'Error',
					errors: [data.message],
				});
			}
		}

		if (data.message && status !== 500 && status !== 401) {
			fieldsWithErrors = [
				{
					name: 'Error',
					errors: [data.message],
				},
				...fieldsWithErrors,
			];
		}

		this.mounted && this.setState({
			...this.state,
			fieldsWithErrors: fieldsWithErrors,
		});

		if (this.refs.errors) {
			let element = ReactDOM.findDOMNode(this.refs.form);
			if (element && typeof element.getAttribute === 'function') {
				const scroller = new SweetScroll({ easing: 'easeOutBounce', offset: -60, duration: 1000 });
				scroller.to('#' + element.getAttribute('id'));
			}

		}
	}

	setWaiting(state) {
		this.mounted && this.setState({ ...this.state, waiting: state });
	}

	renderWaiting() {
		return (
			<div key='spinner' style={{ textAlign: 'center', width: '100%', marginTop: '50px' }}>
				<Spinner size='60' />
			</div>
		);
	}

	serialize() {
		const result = {};
		const inputRefs = this.props.getRefs();

		if (inputRefs) {
			const keys = Object.keys(inputRefs);
			for (let i = 0; i < keys.length; i++) {
				const input = inputRefs[keys[i]];
				if (input && (typeof input.value === 'function') && input.props.name) {
					result[input.props.name] = input.value();
				} else if (input && (input.value !== undefined) && input.props.name) {
					result[input.props.name] = input.value;
				}
			}
		}

		// console.log(decodeURIComponent(qs.stringify(result)));
		return result;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/form/form.js
 **/